import { useSearchParams } from 'react-router-dom';

import { Insights } from '@/components/menu/Insights/Insights';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';

import type { InsightType } from '@/components/menu/Insights/insights.types';

export default function InsightsPage() {
  const [searchParams] = useSearchParams();
  const user = useGlobalStore(getUser);

  const type: InsightType = searchParams.get('type') === 'business' ? 'business' : 'insights';

  return <Insights type={type} user={user.toJSON() as any} />;
}
